import { Component, EventEmitter, AfterViewInit, OnInit, ElementRef, ViewChildren } from '@angular/core';
import { FormControl,
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
  FormControlName} from '@angular/forms';
import { MaterializeAction } from 'angular2-materialize';
import { Guid, DateUtils, SharedUtils, AppUtils } from '../shared/utils';
import { Observable } from 'rxjs/Observable';
import { UserService } from './user.service';
import { GlobalErrorHandler } from '../shared/core/error-handler';
import { NotificationsService, Notification } from '../shared/helper-components/index';
import { IUser } from './user.model';
import { AppService } from '../app.service';
import { GenericValidator } from "../shared/generic-validator";


@Component({
  selector: 'add-user',
  template: require('./add-user.component.html'),
})
export class AddUserComponent implements AfterViewInit, OnInit {
  modalActions = new EventEmitter<string | MaterializeAction>();
  userRole: string = "Production";
  modelParams = [
    {
        dismissible: false,
        complete: function () { console.log('Closed'); }
    }
  ];
  userForm : FormGroup;
  private validationMessages: { [key: string]: { [key: string]: string } };
  private genericValidator: GenericValidator;
  @ViewChildren(FormControlName, { read: ElementRef }) formInputElements: ElementRef[];
  displayMessage: { [key: string]: string } = {};
  constructor(
    private _userService: UserService,
    private _errorHandler: GlobalErrorHandler,
    private _notificationsService: NotificationsService,
    private _appService: AppService,
    private fb: FormBuilder,
  ){
    this.validationMessages = {
      userFirstName: {
          required: 'Please enter the user first name.',
          pattern: 'Please enter the user first name.'
      },
      userLastName: {
        required: 'Please enter the user last name.',
        pattern: 'Please enter the user last name.'
      },
      userEmail: {
        required: 'Please enter the user email.',
        pattern: 'Please enter a valid email.'
      },
    };
    this.genericValidator = new GenericValidator(this.validationMessages);
  }
 
  ngOnInit(): void {
    this.initForm();
  }

  initForm(): void {
    if (!this.userForm){
      this.userForm = this.fb.group({
        userRole: '',
        userFirstName: ['', [Validators.required, Validators.pattern(/.*[^ ].*/)]],
        userLastName: ['', [Validators.required, Validators.pattern(/.*[^ ].*/)]],
        userEmail: ['', [Validators.required, Validators.pattern(/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/)]],
      });
    }
    else{
      this.userForm.controls.userFirstName.reset('');
      this.userForm.controls.userLastName.reset('');
      this.userForm.controls.userEmail.reset('');
    }
    this.userRole = "Production";
  }

  ngAfterViewInit() {
    // moved the animation here since it was interfering with the material modal window (showing behind the main overlay)
    $('.main-container').addClass('animated bounceInUp');
    $('.main-container').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function () {
        $('.main-container').removeClass('animated bounceInUp');
    });
    $('input').attr('tabindex', 1);
    $('select').attr('tabindex', 1);
    $('textarea').attr('tabindex', 1);
    $('button').attr('tabindex', 1);
    $('.picker').attr('tabindex', -1);
    $('.picker__input').attr('tabindex', -1);
    SharedUtils.FixFlickering();

    //Watch for the blur event from any input element on the form.
    let controlBlurs: Observable<any>[] = this.formInputElements
     .map((formControl: ElementRef) => Observable.fromEvent(formControl.nativeElement, 'blur'));

    //Merge the blur event observable with the valueChanges observable
    Observable.merge(this.userForm.valueChanges, ...controlBlurs)
    .debounceTime(500)
    .subscribe(value => {
        this.displayMessage = this.genericValidator.processMessages(this.userForm);
    });
  }

  optionNewUserRole(role: string){
    this.userRole = role;
  }
   
  openAddUserModal(): void {
      $('#modal-add-user').modal('open');
      $('#userFirstName').focus();
  }

  cancelAddUser(): void {
    this.initForm();
    $('#modal-add-user').modal('close');
  }
  
  saveUser(): void {
    if (this.userForm.dirty && this.userForm.valid) {
      let newuser: IUser = {
        userName: this.userForm.controls.userEmail.value,
        email: this.userForm.controls.userEmail.value,
        userRoleName: 'SCRIMS ' + this.userRole,
        name: this.userForm.controls.userFirstName.value.trim() + ' ' + this.userForm.controls.userLastName.value.trim(),
      }
      this._userService.getUser(this.userForm.controls.userEmail.value)
      .subscribe( (user: any) => {
        if (user==null){
          this._userService.addUser(newuser)
          .subscribe(
            (p) => {
              this.onSaveComplete(p);
              $('#modal-add-user').modal('close');
            },
            (error: any) => {
              this._errorHandler.processError(error);
            }
          );
        }
        else{
          let userToUpdate = <IUser>{
            userName: user.UserName,
            name: user.Name,
            email: user.Email,
            userRoleName: user.UserRoleName,
            };
          if (userToUpdate.userRoleName == 'SCRIMS Production' || userToUpdate.userRoleName == 'SCRIMS Clearance'){
          this._notificationsService.add(new Notification('error', `A user with email ${this.userForm.controls.userEmail.value} already exists.`));
          }
          else{
            userToUpdate.userRoleName = 'SCRIMS ' + this.userRole;
            userToUpdate.name = this.userForm.controls.userFirstName.value + ' ' + this.userForm.controls.userLastName.value;
            this._userService.patchUser(userToUpdate)
              .subscribe(
                (p) => {
                  this.onSaveComplete(p);
                  $('#modal-add-user').modal('close');
                },
                (error: any) => {
                  this._errorHandler.processError(error);
                }
              );
          }
        }
      },
      (error: any)=>{
        this._errorHandler.processError(error);
      });
    
    }
    else if (!this.userForm.valid){
      var fieldsNotValid = ''.concat(
          this.userForm.controls.userFirstName.valid ? "" : "First Name|",
          this.userForm.controls.userLastName.valid ? "" : "Last Name|",
          this.userForm.controls.userEmail.valid ? "" : "Email|")
        .split("|");
      fieldsNotValid.splice(-1);
      var validationMessage = `${fieldsNotValid.join(", ")} ${fieldsNotValid.length <=1 ? " is " : " are "} required.`;
      this._notificationsService.add(new Notification('error', validationMessage));  
    }
  }

  onSaveComplete(saveCompleted): void {
    if (!saveCompleted){
      this._notificationsService.add(new Notification('error', `User with email ${this.userForm.controls.userEmail.value} could not be added`));
      return
    }
    var newUserEmail = this.userForm.controls.userEmail.value;
    this._appService.sendNewUserEmail(newUserEmail).subscribe(result => {
      if (result)
        this._notificationsService.add(new Notification('success', `User with email ${this.userForm.controls.userEmail.value} was added and notified successfully`));
      else
        this._notificationsService.add(new Notification('warn', `User with email ${this.userForm.controls.userEmail.value} was added but could NOT be notified by email`));
      this.initForm();
      this.userForm.markAsPristine();
    });
  }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/users/add-user.component.ts